export { default } from "./useSlotProps.js";